var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34Z",
    stroke: "#231F20",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L42 42",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8601 27.94V27.14C13.8601 25.5805 14.4796 24.085 15.5823 22.9822C16.685 21.8795 18.1806 21.2599 19.7401 21.2599H19.9601C21.5161 21.2652 23.0066 21.8872 24.105 22.9893C25.2034 24.0915 25.8201 25.5839 25.8201 27.14V27.94",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.76 18.56C21.4169 18.56 22.76 17.2258 22.76 15.58C22.76 13.9342 21.4169 12.6 19.76 12.6C18.1032 12.6 16.76 13.9342 16.76 15.58C16.76 17.2258 18.1032 18.56 19.76 18.56Z",
    stroke: "#231F20",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.afaa81dc894c3410f2728fc05a082dd9.svg";
export { ForwardRef as ReactComponent };